import { useState } from 'react';

import PriceInputField from 'components/inputs/PriceInputField';

interface PriceInputProps {
  minPrice: number;
  maxPrice: number;
  onChange: (price: number) => void;
  placeholder?: string;
  isDisabled?: boolean;
}

const PriceInput = ({ minPrice, maxPrice, onChange, placeholder, isDisabled }: PriceInputProps) => {
  const [inputValue, setInputValue] = useState<number | undefined>(undefined);

  const handlePriceChange = (newValue?: number) => {
    setInputValue(newValue);
  };

  const handleCommit = () => {
    if (inputValue !== undefined) {
      const clampedPrice = Math.max(minPrice, Math.min(inputValue, maxPrice));
      setInputValue(clampedPrice);
      onChange(clampedPrice);
    }
  };

  const handleBlur = () => {
    handleCommit();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleCommit();
    }
  };

  return (
    <PriceInputField
      value={inputValue}
      onChange={handlePriceChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      maxValue={maxPrice}
      disabled={isDisabled}
    />
  );
};

export default PriceInput;
